import { createSlice } from '@reduxjs/toolkit'

export const auth_slice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    is_logged_in: false
  },
  reducers: {
    set_user(state, action) {
      if (!!action.payload) {
        state.is_logged_in = true;
      } else {
        state.is_logged_in = false;
      }
      state.user = action.payload;
    },
    logout(state) {
      state.user = null;
      state.is_logged_in = false;
      window.localStorage.removeItem("api-token");
      window.localStorage.removeItem("api-refresh-token");
    }
  },
  extraReducers: {}
})

// Action creators are generated for each case reducer function
export const auth_actions = auth_slice.actions;


